import MenuContextProvider from "../../context/menu-context";
import PageContainer from "../../components/PageContainer";
import HeaderOne from "../../components/header-one";
import React from "react";
import ArtistImage from "../../components/artistImage";
import ArtistMenu from "../../components/artistMenu";
import ArtistSummary from "../../components/artistSummary"
import ArtistMediaPlayer from "../../components/artistMediaPlayer";
import FeaturedAlbums from "../../components/featuredAlbums";
import ArtistMusicVideoSlider from "../../components/artistMusicVideoSlider";
import Footer from "../../components/footer";
import ContactArtist from "../../components/contactArtist";
import SocialMediaBanner from "../../components/socialMediaBanner";
import SummaryImage from "../../assets/images/Supraman/supraSummary.jpg";
import backgroundImage from "../../assets/images/bg/supraman.png";
import TheShowGoesOn from "../../assets/images/releases/TheShowGoesOn.png";
import allLove from "../../assets/images/releases/allLove.png";
import moneyPaper from "../../assets/images/releases/moneyPaper.png";
import girls from "../../assets/images/releases/girls.png";
import reboot from "../../assets/images/releases/reboot.png";
import whatCanISay from "../../assets/images/releases/whatCanISay.png";
import videoSliderGif1 from "../../assets/gifs/findMyWayCut.gif";
import videoSliderGif2 from "../../assets/gifs/vaporDreams.gif";
import videoSliderGif3 from "../../assets/gifs/pod3.gif";

class Supraman extends React.Component {
    state = {
        artist: "Supraman",
        artistRealName: "Alan Simpson",
        artistNameLink: "supraman",
        backgroundImage: backgroundImage,
        SummaryImage: SummaryImage,
        artistEmail: "supraman@halfhousestudios.com",
        spotifyArtistLink: "https://open.spotify.com/embed/artist/2Q29TJUDQC1MBN9n7eVSAe?utm_source=generator&theme=0",
        artistSummaryP1: "Born Alan Franklin Simpson, Supraman is a musician and member of Half House from Urbana, IL. " +
            "Involved in music and production since 2007, Supra met whiptrip6 in 2012 and began recording with Half House Studios in 2019.",
        artistSummaryP2: "Supraman's debut album \"Reboot\" was released August 23rd 2021, which saw collaborations with whiptrip6, Mousepad, Herm Everlasting, and relaunched his music career.",
        artistPageMenu: [
            {
                name: "Releases",
                url: "#releases"
            },
            {
                name: "Videos",
                url: "#videos",
            },
            // {
            //     name: "Merch",
            //     url: "/merch"
            // },
            {
                name: "Contact",
                url: "#contact"
            }
        ],
        index: 0,
        mainSlideOptions: {
            slidesPerView: 1,
            loop: true,
            navigation: {
                nextEl: "#main-slider-next",
                prevEl: "#main-slider-prev"
            }
        },
        socialMedia: [
            {

                name: "Instagram",
                url: "https://www.instagram.com/_supra.man/"

            },
            {

                name: "Spotify",
                url: "https://open.spotify.com/artist/2Q29TJUDQC1MBN9n7eVSAe?si=KcGtkvlcRDGnP-8P7LCdug&nd=1"

            }
        ]
    }
    render() {
        return (
            <MenuContextProvider>
                    <PageContainer >
                        <HeaderOne/>
                        <ArtistImage bgImage={this.state.backgroundImage} artist={this.state.artist}/>
                        <ArtistMenu data={this.state}/>
                        <SocialMediaBanner data={this.state.socialMedia} />
                        <ArtistSummary data={this.state}/>
                        <ArtistMediaPlayer data={this.state}/>
                        <FeaturedAlbums data={this.state}/>
                        <ArtistMusicVideoSlider data={this.state}/>
                        <ContactArtist artistEmail={this.state.artistEmail} />
                        <Footer />
                    </PageContainer>
            </MenuContextProvider>
        )
    }
}
export default Supraman;